import { RangoCliente } from '@interfaces/firestore-documents.interfaces';
import { Close } from '@mui/icons-material';
import {
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from '@mui/material';
import useRangeStyles from './ViewRangos.styles';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import useRequests from '@hooks/requests.hook';
interface Props {
	onClose(): void;
	rangosCliente: RangoCliente[];
}

const ViewRangos: React.FC<Props> = ({ onClose, rangosCliente }) => {
	const classes = useRangeStyles();
	const [rangoEditar, setRangoEditar] = useState<number | null>(null);
	const { enqueueSnackbar } = useSnackbar();
	const [dataEditar, setDataEditar] = useState<{
		consecutivo_desde: number | null;
		consecutivo_hasta: number | null;
	}>({
		consecutivo_desde: null,
		consecutivo_hasta: null,
	});
	const { request } = useRequests();

	useEffect(() => {
		function keydownListener(e: globalThis.KeyboardEvent): void {
			if (e.key === 'Escape') {
				onClose();
			}
		}

		document.body.addEventListener('keydown', keydownListener);

		return () => {
			document.body.removeEventListener('keydown', keydownListener);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const editarRangos = (
		idRango: number,
		consecutivo_desde: number,
		consecutivo_hasta: number
	) => {
		setRangoEditar(idRango);
		setDataEditar({
			consecutivo_desde,
			consecutivo_hasta,
		});
	};

	useEffect(() => {
		const wheel = document?.getElementsByClassName('numberInput');
		for (let index = 0; index < wheel.length; index++) {
			wheel[index].addEventListener(
				'wheel',
				function (e) {
					e.preventDefault();
				},
				{ passive: false }
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [rangoEditar]);

	const onSave = async () => {
		try {
			const rango = rangosCliente.filter((i) => i.id_rango === rangoEditar);
			const response = (await request('clientes/suite-maestro-rangos/rango-maestro', 'PUT', {
				id_rango: rangoEditar,
				rango: {
					consecutivo_desde: dataEditar.consecutivo_desde,
					consecutivo_hasta: dataEditar.consecutivo_hasta,
					en_uso: true,
				},
				detalle_rango: {
					nombre: rango[0].nombre,
					direccion: rango[0].direccion,
					telefono: rango[0].telefono,
					ciudad: rango[0].ciudad,
					nombre_ciudad: rango[0].nombre_ciudad,
					correo: rango[0].correo,
				},
			})) as any;

			if (response.isError) {
				throw new Error(response.message);
			}
			setRangoEditar(null);
			setDataEditar({
				consecutivo_desde: null,
				consecutivo_hasta: null,
			});
		} catch (error: any) {
			if (error.response && error.response.data.cause) {
				enqueueSnackbar(error.response.data.cause, { variant: 'error' });
			} else if (typeof error?.message === 'string') {
				enqueueSnackbar(error.message, { variant: 'error' });
			}
		}
	};
	return (
		<div className={classes.root}>
			<div className={classes.rootBg} />
			<section className={classes.container}>
				<header className={classes.headerContainer}>
					<Typography
						color="#003C82"
						fontFamily="Montserrat"
						fontSize={18}
						fontWeight="bold"
					>
						Rango de Guías
					</Typography>
					<IconButton onClick={onClose} sx={{ color: '#686868' }}>
						<Close />
					</IconButton>
				</header>
				<div className={classes.bodyContainer}>
					<TableContainer>
						<Table>
							<TableHead className={classes.thead}>
								<TableRow>
									<TableCell className={classes.tituloTabla} align="center">
										División
									</TableCell>
									<TableCell className={classes.tituloTabla} align="center">
										ID
									</TableCell>
									<TableCell className={classes.tituloTabla} align="center">
										Prefijo
									</TableCell>
									<TableCell className={classes.tituloTabla} align="center">
										Inicial
									</TableCell>
									<TableCell className={classes.tituloTabla} align="center">
										Final
									</TableCell>
									<TableCell className={classes.tituloTabla} align="center">
										Acciones
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{rangosCliente.map((rango) => (
									<TableRow
										key={rango.id_rango}
										sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
									>
										<TableCell style={{ width: '130px' }} align="center">
											{rango.codigo_div}
										</TableCell>

										<TableCell style={{ width: '130px' }} align="center">
											{rango.id_rango}
										</TableCell>

										<TableCell
											style={{
												width: '110px',
											}}
											align="center"
										>
											{rango.prefijo}
										</TableCell>

										<TableCell style={{ width: '150px' }} align="center">
											{rangoEditar === rango.id_rango ? (
												<TextField
													value={dataEditar.consecutivo_desde}
													size="small"
													className={`${classes.textField} numberInput`}
													name={'consecutivo_desde'}
													type="number"
													inputProps={{ min: 0, max: 9999999 }}
													onChange={(e) =>
														setDataEditar({
															...dataEditar,
															consecutivo_desde: Number(
																e.target.value
															),
														})
													}
												/>
											) : (
												rango.consecutivo_desde
											)}
										</TableCell>
										<TableCell style={{ width: '110px' }} align="center">
											{rangoEditar === rango.id_rango ? (
												<TextField
													value={dataEditar.consecutivo_hasta}
													size="small"
													className={`${classes.textField} numberInput`}
													name={'consecutivo_hasta'}
													type="number"
													inputProps={{ min: 0, max: 9999999 }}
													onChange={(e) =>
														setDataEditar({
															...dataEditar,
															consecutivo_hasta: Number(
																e.target.value
															),
														})
													}
												/>
											) : (
												rango.consecutivo_hasta
											)}
										</TableCell>
										<TableCell style={{ width: '150px' }} align="center">
											{rango.id_rango === rangoEditar ? (
												<div>
													<CheckIcon
														onClick={() => onSave()}
														style={{ marginRight: 15 }}
														className={classes.icon}
													/>
													<CloseIcon
														onClick={() => {
															setDataEditar({
																consecutivo_desde: null,
																consecutivo_hasta: null,
															});
															setRangoEditar(null);
														}}
														className={classes.icon}
													/>
												</div>
											) : (
												<EditIcon
													onClick={() =>
														editarRangos(
															rango.id_rango,
															rango.consecutivo_desde,
															rango.consecutivo_hasta
														)
													}
													className={classes.icon}
												/>
											)}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</div>
			</section>
		</div>
	);
};

export default ViewRangos;
